// Configurator catalog — mirrors supabase/migrations/012 seed data.
// The frontend loads families/options/compatibility from Supabase when the
// pricing tables exist; this file is the offline fallback so the configurator
// always renders. Keep in sync with migration 012.

export const doorFamilies = [
  {
    id: '60_OUT',
    slug: 'smartline-standard',
    name: 'Smartline',
    nameEt: 'Smartline',
    opening: 'outward',
    leafMm: 60,
    minWidth: 750, maxWidth: 1200, minHeight: 1800, maxHeight: 2400,
    refWidth: 900, refHeight: 2100
  },
  {
    id: '60_IN',
    slug: 'smartline-inswing',
    name: 'Smartline Inward',
    nameEt: 'Smartline Inward',
    opening: 'inward',
    leafMm: 60,
    minWidth: 750, maxWidth: 1200, minHeight: 1800, maxHeight: 2400,
    refWidth: 900, refHeight: 2100
  },
  {
    id: '60_OUT_PLUS',
    slug: 'smartline-plus',
    name: 'Smartline Plus',
    nameEt: 'Smartline Plus',
    opening: 'outward',
    leafMm: 60,
    minWidth: 750, maxWidth: 1200, minHeight: 1800, maxHeight: 2400,
    refWidth: 900, refHeight: 2100
  },
  {
    id: 'COTTAGE',
    slug: 'cottage-door',
    name: 'Cottage',
    nameEt: 'Cottage',
    opening: 'outward',
    leafMm: 47,
    minWidth: 750, maxWidth: 1200, minHeight: 1800, maxHeight: 2400,
    refWidth: 900, refHeight: 2000
  },
  {
    id: 'MERANTI',
    slug: 'meranti-door',
    name: 'Meranti',
    nameEt: 'Meranti',
    opening: 'outward',
    leafMm: 47,
    minWidth: 750, maxWidth: 1200, minHeight: 1800, maxHeight: 2400,
    refWidth: 900, refHeight: 2000
  },
  {
    id: '18_DEG',
    slug: 'warm-storage-door-18',
    name: '18Deg',
    nameEt: '18Deg',
    opening: 'outward',
    leafMm: 47,
    minWidth: 750, maxWidth: 1200, minHeight: 1800, maxHeight: 2400,
    refWidth: 900, refHeight: 2000
  }
];

export { leafGlassOptions } from './leafGlass.js';

export const configuratorOptions = [
  { id: 'design_blind',      group: 'design',    name: 'Blind leaf',                nameEt: 'Pimendatud laba' },
  { id: 'design_glass',      group: 'design',    name: 'Glass door',                nameEt: 'Klaasuks' },
  { id: 'design_double',     group: 'design',    name: 'Double door',               nameEt: 'Topeltuks' },
  { id: 'design_sidelight',  group: 'design',    name: 'Door with sidelights',      nameEt: 'Küljevalgustiga uks' },
  { id: 'colour_untreated',  group: 'colour',    name: 'Untreated (paint on site)',    nameEt: 'Töötlemata' },
  { id: 'colour_white',      group: 'colour',    name: 'White (RAL 9010)',             nameEt: 'Valge (RAL 9010)' },
  { id: 'colour_offwhite',   group: 'colour',    name: 'Off White (NCS S 0502-Y)',     nameEt: 'Murtud valge (NCS S 0502-Y)' },
  { id: 'colour_black',      group: 'colour',    name: 'Black (RAL 9005)',             nameEt: 'Must (RAL 9005)' },
  { id: 'colour_anthracite', group: 'colour',    name: 'Anthracite Grey (RAL 7016)',   nameEt: 'Antratsiithall (RAL 7016)' },
  { id: 'colour_brown',      group: 'colour',    name: 'Brown (RAL 8017)',             nameEt: 'Pruun (RAL 8017)' },
  { id: 'colour_custom_ncs', group: 'colour',    name: 'Custom NCS colour',            nameEt: 'Eritoon (NCS)' },
  { id: 'colour_custom_ral', group: 'colour',    name: 'Custom RAL colour',            nameEt: 'Eritoon (RAL)' },
  { id: 'glass_none',        group: 'glass',     name: 'No glass',                  nameEt: 'Klaasita' },
  { id: 'glass_2k_clear',    group: 'glass',     name: '2K clear glass',            nameEt: '2K klaas' },
  { id: 'glass_4mm_clear',   group: 'glass',     name: '4 mm clear glass',          nameEt: '4 mm klaas' },
  { id: 'glass_gl016',       group: 'glass',     name: 'Glass GL016',               nameEt: 'Klaas GL016' },
  { id: 'glass_gl019d',      group: 'glass',     name: 'Glass GL019D',              nameEt: 'Klaas GL019D' },
  { id: 'glass_gl003',       group: 'glass',     name: 'Glass GL003',               nameEt: 'Klaas GL003' },
  { id: 'frame_std',         group: 'frame',     name: 'Standard pine frame',       nameEt: 'Standardne männiraam' },
  { id: 'threshold_std',     group: 'threshold', name: 'Standard threshold',        nameEt: 'Standardne lävi' },
  { id: 'threshold_oak',     group: 'threshold', name: 'Oak threshold',             nameEt: 'Tammelävi' },
  { id: 'threshold_accoya',  group: 'threshold', name: 'Accoya threshold',          nameEt: 'Accoya lävi' },
  { id: 'threshold_alu',     group: 'threshold', name: 'Aluminium threshold',       nameEt: 'Alumiiniumlävi' },
  { id: 'threshold_pine',    group: 'threshold', name: 'Pine threshold',            nameEt: 'Männilävi' },
  { id: 'sidelight_none',    group: 'sidelight', name: 'No sidelights',             nameEt: 'Ilma küljevalgustita' },
  { id: 'sidelight_left',    group: 'sidelight', name: 'Sidelight left',            nameEt: 'Küljevalgusti vasakul' },
  { id: 'sidelight_right',   group: 'sidelight', name: 'Sidelight right',           nameEt: 'Küljevalgusti paremal' },
  { id: 'sidelight_both',    group: 'sidelight', name: 'Sidelights on both sides',  nameEt: 'Küljevalgustid mõlemal' },
  { id: 'lock_565',          group: 'lock',      name: 'Lock-case 565',             nameEt: 'Lukukorpus 565' },
  { id: 'lock_fix2150',      group: 'lock',      name: '3-point lock FIX2150',      nameEt: '3-punkti lukk FIX2150' },
  { id: 'lock_assa2002',     group: 'lock',      name: 'ASSA 2002',                 nameEt: 'ASSA 2002' },
  { id: 'lock_mpl410',       group: 'lock',      name: 'MPL-410',                   nameEt: 'MPL-410' },
  { id: 'lock_assa8561',     group: 'lock',      name: 'ASSA 8561',                 nameEt: 'ASSA 8561' },
  { id: 'lock_8765',         group: 'lock',      name: 'Type 8765',                 nameEt: 'Type 8765' },
  { id: 'extra_kickplate',   group: 'extra',     name: 'Kickplate',                 nameEt: 'Löögilaud' },
  { id: 'extra_waternose',   group: 'extra',     name: 'Waternose',                 nameEt: 'Veenina' },
  { id: 'extra_offset_hinge',group: 'extra',     name: 'Offset hinge',              nameEt: 'Nihelennuk (hing)' },
  { id: 'extra_3248_hinge',  group: 'extra',     name: 'Extra 3248 hinge',          nameEt: 'Lisahinge 3248' },
  { id: 'extra_two_colours', group: 'extra',     name: 'Two colours (Smartline)',   nameEt: 'Kaks värvi (Smartline)' },
  { id: 'extra_lines_hdf',   group: 'extra',     name: 'Lines in HDF',              nameEt: 'Jooned HDF-is' },
  { id: 'extra_packaging',   group: 'extra',     name: 'Cardboard packaging',       nameEt: 'Papppakend' },
  { id: 'extra_frame_rear_paint', group: 'extra', name: 'Frame rear-side painting', nameEt: 'Raami tagakülje värvimine' },
  { id: 'hinge_2',           group: 'hinge',     name: '2 hinges',                  nameEt: '2 hinge' },
  { id: 'hinge_3',           group: 'hinge',     name: '3 hinges',                  nameEt: '3 hinge' }
];

// familyId -> { optionId: isDefault } — identical to family_option_compat seed
export const familyCompatibility = {
  '60_OUT': {
    design_blind: true, design_glass: false, design_double: false, design_sidelight: false,
    colour_white: true, colour_offwhite: false, colour_black: false, colour_anthracite: false, colour_brown: false, colour_custom_ncs: false, colour_custom_ral: false,
    glass_none: true, glass_2k_clear: false, glass_gl016: false, glass_gl019d: false, glass_gl003: false,
    frame_std: true,
    threshold_oak: true,
    lock_565: true, lock_fix2150: false, lock_mpl410: false, lock_assa8561: false, lock_8765: false,
    extra_kickplate: false, extra_offset_hinge: false, extra_3248_hinge: false,
    extra_two_colours: false, extra_lines_hdf: false, extra_packaging: false, extra_frame_rear_paint: false,
    sidelight_none: true, sidelight_left: false, sidelight_right: false, sidelight_both: false,
    hinge_3: true, hinge_2: false
  },
  '60_OUT_PLUS': {
    design_blind: true, design_glass: false, design_double: false, design_sidelight: false,
    colour_white: true, colour_offwhite: false, colour_black: false, colour_anthracite: false, colour_brown: false, colour_custom_ncs: false, colour_custom_ral: false,
    glass_none: true, glass_2k_clear: false, glass_gl016: false, glass_gl019d: false, glass_gl003: false,
    frame_std: true,
    threshold_alu: true,
    lock_565: true, lock_fix2150: false, lock_mpl410: false, lock_assa8561: false, lock_8765: false,
    extra_kickplate: false, extra_offset_hinge: false, extra_3248_hinge: false,
    extra_two_colours: false, extra_lines_hdf: false, extra_packaging: false, extra_frame_rear_paint: false,
    sidelight_none: true, sidelight_left: false, sidelight_right: false, sidelight_both: false,
    hinge_3: true, hinge_2: false
  },
  '60_IN': {
    design_blind: true, design_glass: false, design_double: false, design_sidelight: false,
    colour_white: true, colour_offwhite: false, colour_black: false, colour_anthracite: false, colour_brown: false, colour_custom_ncs: false, colour_custom_ral: false,
    glass_none: true, glass_2k_clear: false, glass_gl016: false, glass_gl019d: false, glass_gl003: false,
    frame_std: true,
    threshold_alu: true,
    lock_565: true, lock_fix2150: false, lock_mpl410: false, lock_assa8561: false, lock_8765: false,
    extra_kickplate: false, extra_offset_hinge: false, extra_3248_hinge: false,
    extra_two_colours: false, extra_lines_hdf: false, extra_packaging: false, extra_frame_rear_paint: false,
    sidelight_none: true, sidelight_left: false, sidelight_right: false, sidelight_both: false,
    hinge_3: true, hinge_2: false
  },
  'COTTAGE': {
    design_blind: true, design_glass: false, design_double: false, design_sidelight: false,
    colour_untreated: true, colour_white: false, colour_offwhite: false, colour_black: false, colour_anthracite: false, colour_brown: false, colour_custom_ncs: false, colour_custom_ral: false,
    glass_none: true, glass_4mm_clear: false, glass_gl016: false, glass_gl019d: false, glass_gl003: false,
    frame_std: true,
    threshold_pine: true, threshold_oak: false,
    lock_565: true, lock_fix2150: false, lock_mpl410: false, lock_assa8561: false, lock_8765: false,
    extra_kickplate: false, extra_waternose: true, extra_offset_hinge: false, extra_3248_hinge: false, extra_lines_hdf: false, extra_packaging: false, extra_frame_rear_paint: false,
    sidelight_none: true, sidelight_left: false, sidelight_right: false, sidelight_both: false,
    hinge_3: true, hinge_2: false
  },
  'MERANTI': {
    design_blind: true, design_glass: false, design_double: false, design_sidelight: false,
    colour_untreated: true, colour_white: false, colour_offwhite: false, colour_black: false, colour_anthracite: false, colour_brown: false, colour_custom_ncs: false, colour_custom_ral: false,
    glass_none: true, glass_4mm_clear: false, glass_gl016: false, glass_gl019d: false, glass_gl003: false,
    frame_std: true,
    threshold_std: true,
    lock_565: true, lock_fix2150: false, lock_mpl410: false, lock_assa8561: false, lock_8765: false,
    extra_kickplate: false, extra_offset_hinge: false, extra_3248_hinge: false, extra_lines_hdf: false, extra_packaging: false, extra_frame_rear_paint: false,
    sidelight_none: true, sidelight_left: false, sidelight_right: false, sidelight_both: false,
    hinge_3: true, hinge_2: false
  },
  '18_DEG': {
    design_blind: true, design_glass: false, design_double: false, design_sidelight: false,
    colour_untreated: true, colour_white: false, colour_offwhite: false, colour_black: false, colour_anthracite: false, colour_brown: false, colour_custom_ncs: false, colour_custom_ral: false,
    glass_none: true, glass_2k_clear: false, glass_gl016: false, glass_gl019d: false, glass_gl003: false,
    frame_std: true,
    threshold_pine: true, threshold_oak: false, threshold_accoya: false,
    lock_565: true, lock_fix2150: false, lock_mpl410: false, lock_assa8561: false, lock_8765: false,
    extra_kickplate: false, extra_waternose: true, extra_offset_hinge: false, extra_3248_hinge: false, extra_lines_hdf: false, extra_packaging: false, extra_frame_rear_paint: false,
    sidelight_none: true, sidelight_left: false, sidelight_right: false, sidelight_both: false,
    hinge_3: true, hinge_2: false
  }
};

// Options valid for a family, grouped — shape the UI consumes.
export const optionsForFamily = (familyId, sourceOptions, sourceCompat) => {
  const opts = sourceOptions || configuratorOptions;
  const compat = sourceCompat || familyCompatibility;
  const allowed = compat[familyId] || {};
  const byGroup = {};
  for (const opt of opts) {
    if (!(opt.id in allowed)) continue;
    const group = opt.group_key || opt.group;
    (byGroup[group] = byGroup[group] || []).push({
      ...opt,
      isDefault: !!allowed[opt.id]
    });
  }
  return byGroup;
};

export const defaultConfigForFamily = (familyId, sourceOptions, sourceCompat) => {
  const grouped = optionsForFamily(familyId, sourceOptions, sourceCompat);
  const cfg = {};
  for (const [group, opts] of Object.entries(grouped)) {
    if (group === 'extra') continue;
    const def = opts.find((o) => o.isDefault) || opts[0];
    if (def) cfg[group] = def.id;
  }
  return cfg;
};
